<template>
  <section
    class="jps-item-metatables"
    :aria-label="ls(dapLangGlobal.metadata.common.label)"
  >
    <dl class="jps-item-common-fields" v-if="contributors.length > 0">
      <dt>{{ ls(contributorLabel) }}</dt>
      <dd v-for="v in contributors" :key="v">
        <BaseLink :nolink="isWebParts" :to="searchTo('contributor', v)">{{ v }}</BaseLink>
      </dd>
    </dl>
    <dl class="jps-item-common-fields" v-if="locations.length > 0">
      <dt>{{ ls(locationLabel) }}</dt>
      <dd v-for="v in locations" :key="v">
        <BaseLink :nolink="isWebParts" :to="searchTo('location', v)">{{ v }}</BaseLink>
      </dd>
    </dl>
    <dl class="jps-item-common-fields" v-if="temporals.length > 0">
      <dt>{{ ls(temporalLabel) }}</dt>
      <dd v-for="v in temporals" :key="v">
        <BaseLink :nolink="isWebParts" :to="searchTo('temporal', v)">{{ v }}</BaseLink>
      </dd>
    </dl>
  </section>
</template>

<script lang="ts" setup>
import { dapLangGlobal } from '#imports'

const { isWebParts } = useWebParts()
const { ls, lss } = useI18n()
const { $getCommonLabelDef } = useNuxtApp()

interface Props {
  item: Item
  label: Label
}
const props = withDefaults(defineProps<Props>(), {})

const contributors = computed(() => {
  return unqueNonEmptyArray(props.item.common.contributor)
})

const locations = computed(() => {
  return unqueNonEmptyArray(props.item.common.location)
})

const temporals = computed(() => {
  return unqueNonEmptyArray(props.item.common.temporal)
})

const contributorLabel = $getCommonLabelDef().filter(
  l => l.id === 'contributor',
).pop()?.name
const locationLabel = $getCommonLabelDef().filter(l => l.id === 'location').pop()
  ?.name
const temporalLabel = $getCommonLabelDef().filter(l => l.id === 'temporal').pop()
  ?.name

const searchTo = (field: string, value: string) => {
  return `/csearch/${systemCrossSearchId()}?csid=${systemCrossSearchId()}&from=0&q-common.${field}=${value}`
}
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.jps-item-metatables {
  display: flex;
  flex-flow: wrap;
  .jps-item-common-fields {
    margin-right: 2rem;
    position: relative;
    display: flex;
    flex-flow: wrap;
    margin-top: 1.25rem;
    dt {
      color: $jps-gray-600;
      font-size: 0.875rem;
      position: absolute;
      top: -1.25rem;
      left: 0;
      min-width: 4rem;
    }
    dd {
      padding-left: 1rem;
    }
  }
}
</style>
